import React, { useState, useRef, useEffect, useId, isValidElement } from "react";
import { PopoverProps } from "./typer";

export function SVVPopover({
  explanationText,
  closeText = "Lukk",
  title,
  ariaLabel = "Ordforklaring for ",
  headingLevel = "h3",
}: PopoverProps) {
  const [open, setOpen] = useState<boolean>(false);
  const containerId = useId();

  const popoverRef = useRef<HTMLDivElement | null>(null);
  const triggerRef = useRef<HTMLButtonElement | null>(null);

  const HLevel = headingLevel;

  const handleOutsideClick = (event: MouseEvent) => {
    const { target } = event;
    if (target instanceof Node) {
      if (!popoverRef.current?.contains(target) && event.target !== triggerRef.current) {
        setOpen(false);
      }
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleOutsideClick, true);

    return () => {
      document.removeEventListener("click", handleOutsideClick, true);
    };
  }, []);

  const handleEscapeKey = (event: KeyboardEvent) => {
    if (event.key.toLowerCase() === "escape") {
      setOpen(false);
    }
  };

  const setArrowPlacement = () => {
    const left = triggerRef.current?.offsetLeft;

    let iconPos = 6;

    if (left) {
      iconPos += left;
    }

    const popover = document.getElementById(containerId);
    popover?.style.setProperty("--icon-position", `${iconPos}px`);
  };

  useEffect(() => {
    if (open) {
      document.addEventListener("keydown", handleEscapeKey, true);
      setArrowPlacement();
    }
    return () => {
      document.removeEventListener("keydown", handleEscapeKey, true);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return (
    <div className="svv-popover-container">
      <button
        ref={triggerRef}
        type="button"
        className="svv-popover-trigger"
        aria-controls={containerId}
        aria-expanded={open}
        aria-label={`${ariaLabel}${title}`}
        onClick={() => setOpen(!open)}
      />

      <div ref={popoverRef} id={containerId} className="svv-helptext-container" hidden={!open}>
        <div>
          <HLevel className="svv-h6 svv-padding-bottom--px8" style={{ fontWeight: "600" }}>
            {title}
          </HLevel>
          <button
            className="svv-popover__close-button"
            type="button"
            onClick={() => setOpen(false)}
            aria-label={closeText}
          />
        </div>
        {isValidElement(explanationText) ? explanationText : <p>{explanationText}</p>}
      </div>
    </div>
  );
}
